import Users from './Users.vue';

export default Users;
